const diagRoutes = [
  {
    path: "diag",
    meta: {
      title: "GQF 역량진단",
      titleEn: "Diagnosis Management",
    },
    children: [
      {
        path: "core", // diag/core
        meta: {
          title: "GQF 역량진단 관리",
          titleEn: "Core Ability Diagnosis",
          isDynamic: true,
        },
        children: [
          {
            path: "qus", // diag/core/qus
            children: [
              {
                path: "", // diag/core/qus
                meta: {
                  title: "진단문항 관리",
                  titleEn: "Diagnosis Question Management",
                  isDynamic: true,
                  menuCd: "DIAG_CORE_QUS",
                },
                component: () => import("@/views/diag/core/qus/DiagCoreQusIndex.vue"),
              },
              {
                path: "detail", // diag/core/qus/detail
                meta: {
                  title: "진단문항 등록/수정",
                  titleEn: "Diagnosis Question Registration/Modification",
                  isDynamic: true,
                  menuCd: "DIAG_CORE_QUS",
                },
                component: () => import("@/views/diag/core/qus/DiagCoreQusDetail.vue"),
              },
            ],
          },
          {
            path: "plan", // diag/core/plan
            children: [
              {
                path: "", // diag/core/plan
                meta: {
                  title: "진단 관리",
                  titleEn: "Diagnosis Management",
                  isDynamic: true,
                  menuCd: "DIAG_CORE_PLAN",
                },
                component: () => import("@/views/diag/core/plan/DiagCorePlanIndex.vue"),
              },
              {
                path: "detail", // diag/core/plan/detail
                meta: {
                  title: "진단 등록/수정",
                  titleEn: "Diagnosis Registration/Modification",
                  isDynamic: true,
                  menuCd: "DIAG_CORE_PLAN",
                },
                component: () => import("@/views/diag/core/plan/DiagCorePlanDetail.vue"),
              },
              {
                path: "result", // diag/core/plan/result
                meta: {
                  title: "진단 결과",
                  isDynamic: true,
                  menuCd: "DIAG_CORE_PLAN",
                },
                component: () => import("@/views/diag/core/result/DiagCoreResultIndex.vue"),
              },
            ],
          },
        ],
      },
    ],
  },
];
export default diagRoutes;
